import { Box } from "@mui/material";
import ImagePickerWithoutCrop from "../ImagePickerWithoutCrop/ImagePickerWithoutCrop";
import TextBox from "../TextBox/TextBox";

const ImageWithTextBox = ({
  field,
  errors,
  register,
  state,
  updateField,
  clearErrors,
  handleChange,
  handleOnBlur,
  containerSize,
  isDisabled = false,
}: any) => {
  // Define field names for image and text
  const imageFieldName = field?.children?.[0]?.name;
  const textFieldName = field?.children?.[1]?.name;

  return (
    <Box
      id={`${field?.name}_id`}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        width: "100%",
      }}>
      <ImagePickerWithoutCrop
        field={field?.children?.[0]}
        error={errors?.[imageFieldName]}
        register={register}
        data={state?.[imageFieldName] || ""}
        updateField={updateField}
        containerSize={containerSize}
        aspect_ratio={field?.aspect_ratio}
        isDisabled={isDisabled}
      />
      <Box sx={{ width: "inherit" }}>
        <TextBox
          field={field?.children?.[1]}
          error={errors?.[textFieldName]}
          isDisabled={isDisabled}
          register={register}
          clearErrors={clearErrors}
          handleChange={handleChange}
          handleOnBlur={handleOnBlur}
          data={state?.[textFieldName] || ""}
          type={"text"}
        />
      </Box>
    </Box>
  );
};

export default ImageWithTextBox;
